import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject;

import { cloneElement } from 'react';
import styled from 'styled-components';
import { getRem } from "./../../core";
var ToastIcon = styled(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/cloneElement(children, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", ";\n  height: ", ";\n  width: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.additional.light.value;
}, getRem('24px'), getRem('24px'));
export { ToastIcon };